
class StickyBar extends HTMLElement {
  constructor() {
    super();

    this.body = document.querySelector("body");
    this.productForm = document.querySelector("product-form");
    this.button = this.productForm.querySelector(".product-form__submit");
    this.header = document.querySelector(".header");

    this.mainQuantity = this.productForm.querySelector('input[name="quantity"]');
    this.stickyQuantity = this.querySelector('input[name="quantity"]');


    if (this.productForm) this.addObserver();
    if (this.mainQuantity && this.stickyQuantity) this.addListeners();
    this.checkforPromo();
  }

  addListeners() {
    this.mainQuantity.addEventListener("change", () => {
      this.updateQuantity(this.mainQuantity.value);
    });

    this.stickyQuantity.addEventListener("change", () => {
      this.updateQuantity(this.stickyQuantity.value);
    });
  }

  addObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.remove("active");
          } else {
            this.classList.add("active");
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(this.button);
  }

  checkforPromo() {
    const timeout = 10000;
    const intervalTime = 100; 
    let timeElapsed = 0;

    const interval = setInterval(() => {
      const thirdPartyPromo = document.querySelector('sticky-header .yie-outer-element');
      if (thirdPartyPromo) {
        clearInterval(interval);
        setTimeout(() => {
          const promoHeight = thirdPartyPromo.offsetHeight;
          document.documentElement.style.setProperty('--promo-height', `${promoHeight}px`);
        }, 1000);
      } else if (timeElapsed >= timeout) {
        clearInterval(interval);
      }
      timeElapsed += intervalTime;
    }, intervalTime);
  }

  updateQuantity(quantity) {
    if (this.mainQuantity) {
      this.mainQuantity.value = quantity;
      const minusButton = this.mainQuantity.parentElement.querySelector(
        'button[name="minus"]'
      );
      if (minusButton) {
        if (this.mainQuantity.value == this.mainQuantity.min) {
          minusButton.setAttribute("disabled", true);
        } else {
          minusButton.removeAttribute("disabled");
        }
      }
    }

    if (this.stickyQuantity) {
      this.stickyQuantity.value = quantity;
      const minusButton = this.stickyQuantity.parentElement.querySelector(
        'button[name="minus"]'
      );
      if (minusButton) {
        if (this.stickyQuantity.value == this.stickyQuantity.min) {
          minusButton.setAttribute("disabled", true);
        } else {
          minusButton.removeAttribute("disabled");
        }
      }
    }
  }
}

customElements.define("sticky-bar", StickyBar);
